<template>
	<div style="display: contents">
		<v-menu
			v-model="menu"
			bottom
			offset-y
			:close-on-content-click="false"
			transition="slide-y-transition"
			content-class="round-card"
			max-width="400"
			nudge-left="100"
			:z-index="2100">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					v-bind="attrs"
					v-on="on">
					<v-icon
						:color="isCurrentPageFavorited ? ($vuetify.theme.dark ? 'yellow' : 'amber darken-2') : ''"
						:class="!isCurrentPageFavorited ? $eventBusUtility.iconAppBarColor : ''">
						{{ isCurrentPageFavorited ? 'mdi-star' : 'mdi-star-outline' }}
					</v-icon>
				</v-btn>
			</template>

			<v-card class="background-2 round-card">
				<v-card-title class="pb-2">
					<v-icon left :color="isCurrentPageFavorited ? ($vuetify.theme.dark ? 'yellow' : 'amber darken-2') : ''">mdi-star</v-icon>
					Preferiti
				</v-card-title>

				<v-divider></v-divider>

				<!-- Add/Remove current page button -->
				<v-card-actions class="px-4 py-2">
					<v-btn
						v-if="!isCurrentPageFavorited"
						color="primary"
						block
						@click="addCurrentToFavorites">
						<v-icon left>mdi-plus</v-icon>
						Aggiungi questa pagina
					</v-btn>
					<v-btn
						v-else
						color="error"
						block outlined
						@click="removeCurrentFromFavorites">
						<v-icon left>mdi-delete</v-icon>
						Rimuovi questa pagina
					</v-btn>
				</v-card-actions>

				<v-divider v-if="favorites.length > 0"></v-divider>

				<!-- Search bar -->
				<v-card-text v-if="favorites.length > 5" class="pb-0 pl-2">
					<v-text-field
						v-model="search"
						prepend-icon="mdi-magnify"
						label="Cerca nei preferiti"
						outlined
						dense
						hide-details
						clearable
					></v-text-field>
				</v-card-text>

				<!-- Favorites list -->
					<v-list v-if="displayFavorites.length > 0" class="background-2" dense>
						<draggable
							v-model="displayFavorites"
							handle=".drag-handle"
							@end="onDragEnd"
							:disabled="!!search">
							<v-list-item
								v-for="favorite in displayFavorites"
								:key="favorite.id"
								@click="handleItemClick(favorite)"
								class="favorite-item">
								<v-list-item-icon class="drag-handle mr-2 ma-auto" v-if="!search">
									<v-icon class="ma-auto">mdi-drag-vertical</v-icon>
								</v-list-item-icon>

								<!-- <v-list-item-icon>
									<v-icon>{{ favorite.icon || 'mdi-star' }}</v-icon>
								</v-list-item-icon> -->

								<v-list-item-content>
									<v-list-item-title v-if="editingId !== favorite.id">{{ favorite.title }}</v-list-item-title>
									<v-text-field
										v-else
										v-model="editingTitle"
										@keyup.enter="saveTitle(favorite)"
										@keyup.esc="cancelEdit"
										dense class="ma-auto" solo
										hide-details
										single-line
										autofocus
										@click.stop
									></v-text-field>
								</v-list-item-content>
									<v-tooltip bottom v-if="editingId !== favorite.id">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												small
												color="teal"
												@click.stop="startEdit(favorite)"
												v-bind="attrs"
												v-on="on">
												<v-icon small>mdi-pencil</v-icon>
											</v-btn>
										</template>
										<span>Modifica nome</span>
									</v-tooltip>
									<v-tooltip bottom v-else>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												small
												color="success"
												@click.stop.prevent="saveTitle(favorite)"
												v-bind="attrs"
												v-on="on">
												<v-icon small>mdi-check</v-icon>
											</v-btn>
										</template>
										<span>Conferma modifica</span>
									</v-tooltip>

									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												small
												color="red"
												@click.stop="removeFavorite(favorite)"
												v-bind="attrs"
												v-on="on">
												<v-icon small>mdi-close</v-icon>
											</v-btn>
										</template>
										<span>Rimuovi dai preferiti</span>
									</v-tooltip>
							</v-list-item>
						</draggable>
					</v-list>

					<div v-else class="pa-4 text-center">
						<v-icon large color="grey">mdi-star-outline</v-icon>
						<p class="grey--text mt-2">
							{{ search ? 'Nessun preferito trovato' : 'Nessun preferito salvato' }}
						</p>
					</div>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';

export default {
	name: 'FavoritesMenu',
	components: {
		draggable
	},
	data() {
		return {
			menu: false,
			search: '',
			editingId: null,
			editingTitle: '',
			localFavorites: []
		};
	},
	computed: {
		...mapGetters('favorites', [
			'favorites',
			'isCurrentPageFavorited'
		]),
		displayFavorites: {
			get() {
				if (this.search) {
					const searchLower = this.search.toLowerCase();
					return this.localFavorites.filter(f =>
						f.title.toLowerCase().includes(searchLower)
					);
				}
				return this.localFavorites;
			},
			set(value) {
				if (!this.search) {
					this.localFavorites = value;
				}
			}
		},
		currentPageTitle() {
			// Prova a ottenere il titolo dal meta, dal nome della route o dal document title
			if (this.$route.meta && this.$route.meta.title) {
				return this.$route.meta.title;
			}
			if (this.$route.name) {
				// Trasforma il nome della route in un titolo leggibile
				return this.$route.name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
			}
			return document.title || 'Pagina corrente';
		},
		currentPageIcon() {
			return this.$route.meta?.icon || 'mdi-file';
		}
	},
	methods: {
		...mapActions('favorites', [
			'fetchFavorites',
			'addFavorite',
			'removeFavoriteById',
			'reorderFavorites',
			'checkCurrentPage',
			'updateFavoriteTitle'
		]),
		async addCurrentToFavorites() {
			const favoriteData = {
				title: this.currentPageTitle,
				url: this.$route.fullPath,
				route_name: this.$route.name,
				route_params: this.$route.params,
				icon: this.currentPageIcon
			};

			try {
				await this.addFavorite(favoriteData);
				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: 'Aggiunto ai preferiti',
					value: true,
					color: 'success'
				});
				// Ricontrolla lo stato della pagina corrente
				await this.checkCurrentPage(this.$route.fullPath);
			} catch (error) {
				if (error.response && error.response.status === 409) {
					// La pagina è già nei preferiti, aggiorna lo stato
					await this.checkCurrentPage(this.$route.fullPath);
					this.$store.commit('setSnackbar', {
						timeout: 3000,
						text: 'Questa pagina è già nei tuoi preferiti',
						value: true,
						color: 'warning'
					});
				} else {
					this.$store.commit('setSnackbar', {
						timeout: 3000,
						text: 'Errore nell\'aggiungere ai preferiti',
						value: true,
						color: 'error'
					});
				}
			}
		},
		async removeCurrentFromFavorites() {
			const current = this.favorites.find(f => f.url === this.$route.fullPath);
			if (current) {
				await this.removeFavorite(current);
			}
		},
		async removeFavorite(favorite) {
			try {
				await this.removeFavoriteById(favorite.id);
				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: 'Rimosso dai preferiti',
					value: true,
					color: 'success'
				});
			} catch (error) {
				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: 'Errore nel rimuovere dai preferiti',
					value: true,
					color: 'error'
				});
			}
		},
		handleItemClick(favorite) {
			// Solo naviga se non stiamo modificando
			if (this.editingId !== favorite.id) {
				this.navigateToFavorite(favorite);
			}
		},
		navigateToFavorite(favorite) {
			this.menu = false;
			if (favorite.route_name && this.$router.resolve({ name: favorite.route_name })) {
				this.$router.push({
					name: favorite.route_name,
					params: favorite.route_params || {}
				});
			} else {
				this.$router.push(favorite.url);
			}
		},
		async onDragEnd() {
			const reorderedFavorites = this.localFavorites.map((f, index) => ({
				id: f.id,
				position: index
			}));
			await this.reorderFavorites(reorderedFavorites);
		},
		startEdit(favorite) {
			this.editingId = favorite.id;
			this.editingTitle = favorite.title;
		},
		cancelEdit() {
			this.editingId = null;
			this.editingTitle = '';
		},
		async saveTitle(favorite) {
			if (!this.editingTitle || this.editingTitle === favorite.title) {
				this.cancelEdit();
				return;
			}

			try {
				await this.updateFavoriteTitle({ id: favorite.id, title: this.editingTitle });
				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: 'Preferito rinominato',
					value: true,
					color: 'success'
				});
			} catch (error) {
				this.$store.commit('setSnackbar', {
					timeout: 3000,
					text: 'Errore nel rinominare il preferito',
					value: true,
					color: 'error'
				});
			} finally {
				this.cancelEdit();
			}
		}
	},
	watch: {
		'$route'() {
			this.checkCurrentPage(this.$route.fullPath);
		},
		favorites: {
			handler(newVal) {
				this.localFavorites = [...newVal];
			},
			deep: true,
			immediate: true
		},
		menu(val) {
			// Quando il menu si chiude, cancella la modalità di modifica
			if (!val && this.editingId) {
				this.cancelEdit();
			}
		}
	},
	mounted() {
		this.fetchFavorites();
		this.checkCurrentPage(this.$route.fullPath);
	}
};
</script>

<style scoped>
	.favorite-item {
		cursor: pointer;
		padding-left: 8px;
		padding-right: 8px;
	}

	.favorite-item:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}

	.drag-handle {
		cursor: move;
	}
</style>